import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { styles } from './styles';

function ImageComponent (props) {
    const { blockProps: { url, alt }, classes } = props;
    return (
        <div className={classes.container}>
            <img
                className={classes.image}
                src={url}
                alt={alt}
            />
        </div>
    );
}

export default withStyles(styles)(ImageComponent);
